// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {useStore} from '@nanostores/react';
import {$user, $loading, $is_root} from '@pub/store/user.js';
import {Button} from '@pub/comp/button';
import {Balance} from '@pub/comp/balance';
import {Removed_badge} from '@pub/comp/removed_badge';
import {User} from '@pub/comp/user';
import {Text} from '@pub/comp/text';
import {Icon} from '@pub/comp/icon';
import {Notifs_center} from '@pub/features/notifs_center';
import {Selected_user} from '@pub/comp/selected_user';
import {Suspension} from '@pub/features/root_zone';
import {get_path, g_path} from '@pub/utils/path.js';
import logo_src from '@pub/img/earnapp_logo.svg';
import * as cns from './header.module.less';

const TIP_DELAY = 0.1;

const render_user = (user, is_root)=>{
    const profile_url = get_path(g_path('/me'));
    const has_selected = !!user.original_user;
    const current_user = user.original_user || user;
    const btn = <Button color_scheme="tertiary" filled size="s" ico="pending"
      tip={<Suspension user={user}/>} tip_show_delay_s={TIP_DELAY}/>;
    return <>
      {is_root&&<Selected_user user={has_selected ? user : null}
        center_content={btn}/>}
      <User user={current_user} to={profile_url} hide_name={has_selected}/>
    </>;
};

function Controls({user, is_root}){
    return user
        ? <>
          {!!user.delete_ts&&<Removed_badge user={user}/>}
          <Balance compact/>
          {render_user(user, is_root)}
          <Notifs_center/>
        </>
        : <>
          <Button color_scheme="secondary" filled size="s"
            href={get_path(g_path('/signin'))}>
            Sign in
          </Button>
          <Button color_scheme="secondary" filled size="s"
            href={get_path(g_path('/signup'))}>
            Sign up
        </Button>
    </>;
}

export function Header({className}){
    const user = useStore($user);
    const is_root = useStore($is_root);
    const loading = useStore($loading);
    return <div className={cn(cns.root, className)}>
      <div className={cns.container}>
        <a className={cns.logo_wrap} href="/">
          <img className={cns.logo} src={logo_src}/>
          {is_root&&<Text.xs className={cns.roots} bold>for roots</Text.xs>}
        </a>
        <div className={cns.right}>
          {loading
            ? <Icon ico="spinner" color="" size="l"/>
            : <Controls user={user} is_root={is_root}/>}
        </div>
      </div>
    </div>;
}
